import React from 'react';
import Terminal from './TerminalSite/Terminal';
import './App.css';

function App() {
  return (
      <div className="App">
        <Terminal />
      </div>
  );
}

export default App;
